// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"105":"a18ba6f1","239":"9fb489f9"}[chunkId] + ".chunk.js";
};